module.exports = __webpack_public_path__ + "img/ปลาหมึกยักษ์.62727be9.jpeg";